/**
 * Thao tác hàng loạt
 */
export default {
  // Xóa
  Delete: 0,
  // Từ chối duyệt
  Reject: 1,
  // Duyệt
  Approve: 2,
  // Gửi duyệt
  SendApproval: 3,
};
